import compact from 'lodash/compact';
import isFunction from 'lodash/isFunction';
import {
  PaginationState,
} from '@tanstack/react-table';
import {
  ReportDTO,
} from 'dtos/reportDTO';
import {
  postApiReportGetReports,
} from 'endpoints';
import {
  MediaOriginatorType,
} from 'pages/Dashboard/utils/constants';
import {
  serializeDateRange,
} from 'pages/Dashboard/transport/dateRange';
import {
  DateRange,
} from 'types/dateRange';

type ReportsDataParams = {
  dateRange?: DateRange;
  pagination?: PaginationState;
  setTotalSize?: (size: number) => void;
  requestMedia?: (ids: number[], originatorType?: MediaOriginatorType) => void;
};

async function getRequestedReportList(
  {
    dateRange,
    pagination,
    setTotalSize,
    requestMedia,
  }: ReportsDataParams,
): Promise<ReportDTO[]> {
  const { reportResults } = await postApiReportGetReports({
    dateRange: serializeDateRange(dateRange),
    pageRequest: {
      page: pagination?.pageIndex ?? 0,
      pageSize: pagination?.pageSize ?? 25,
    },
  });
  setTotalSize?.(reportResults?.pageProperties?.totalSize ?? 0);

  const data = reportResults?.data ?? [];

  if (isFunction(requestMedia)) {
    const userIds = compact(data.map((item) => item.requestedByUserDTO?.userId));
    requestMedia(userIds, MediaOriginatorType.User);
  }

  return [...data];
}

export default getRequestedReportList;
